import TimeOffCalendar from "features/hr/absenceReport/views/TimeOffCalendar";
import { useEffect, useState } from "react";
import { useGetMyAbsenceStatsQuery } from "features/hr/absenceReport/api/absenceReportApiSlice";
import { getFirstTimestampOfMonth, getLastTimestampOfMonth } from "utility/MonthTimeUility";



export default function MyOvertimesCalendar() {

    // Stati per le date di inizio e fine del mese
    const [startDate, setStartDate] = useState(getFirstTimestampOfMonth());
    const [endDate, setEndDate] = useState(getLastTimestampOfMonth());

    // Query API
    const {
        data: absenceReportsUi,
        isSuccess: isAbsentsSuccess,
        isFetching: isAbsentsFetching,
        isError: isAbsentsError,
        error: absentsError,
        refetch: refetchAbsents
    } = useGetMyAbsenceStatsQuery({ start: startDate, end: endDate });

    // Effetto per aggiornare la query quando le date cambiano
    useEffect(() => {
        refetchAbsents(); // Ricarica i dati quando le date cambiano
    }, [startDate, endDate]);

    // Funzione per gestire il cambio mese
    const handleMonthChange = (start, end) => {
        console.log("MonthChanged")
        setStartDate(start);
        setEndDate(end);
    };

    return <TimeOffCalendar
        data={isAbsentsSuccess ? absenceReportsUi.overtimes : null}
        isFetching={isAbsentsFetching}
        isSuccess={isAbsentsSuccess}
        refetch={handleMonthChange}
    />

}